import { lineChart } from "#root/dashboard/charts/components/line_chart";
import { $ } from "#root/dashboard/l10n";
import { numberSpacing } from "#root/lib/formatting";
export function lineChartBox(chart, chartCard, repaint, repaintArguments) {
  if (chart.sets === null || chart.sets === undefined) chart.sets = [];

  if (chart.sets.length < 1 || chart.sets[0].points.length < 1) {
    const chartHolder = document.createElement("div");
    chartHolder.innerText = $("not_enough_data");
    return chartHolder;
  }

  if (chart.sets[0].points.length === 1) {
    const chartHolder = document.createElement("div");
    chartHolder.classList.add("chart-list");
    const chartTable = document.createElement("table");
    chartTable.classList.add("chart-table");
    chartHolder.appendChild(chartTable);

    for (const set of chart.sets) {
      const point = set.points[0];
      const setContainer = document.createElement("tr");
      setContainer.classList.add("text-set-container");
      chartTable.appendChild(setContainer);
      const label = document.createElement("td");
      label.classList.add("text-set-label");
      label.textContent = set.label + ": ";
      const value = document.createElement("td");
      value.classList.add("text-set-value");
      value.textContent = point.yFormatted || numberSpacing(point.y);
      setContainer.appendChild(label);
      setContainer.appendChild(value);
    }

    return chartHolder;
  }

  function createChartScaffold() {
    const chartHolder = document.createElement("div");
    chartHolder.classList.add("chart-holder");
    const yChartAxis = document.createElement("div");
    yChartAxis.classList.add("chart-axis-y");
    chartHolder.appendChild(yChartAxis);
    const chartViewport = document.createElement("div");
    chartViewport.classList.add("chart-viewport");
    chartHolder.appendChild(chartViewport);
    const xChartAxis = document.createElement("div");
    xChartAxis.classList.add("chart-axis-x");
    chartHolder.appendChild(xChartAxis);
    const canvas = document.createElement("canvas");
    canvas.classList.add("chart-canvas");
    chartViewport.appendChild(canvas);
    return {
      chartHolder,
      canvas,
      xChartAxis,
      yChartAxis,
      chartViewport
    };
  }

  const {
    chartHolder,
    canvas,
    xChartAxis,
    yChartAxis,
    chartViewport
  } = createChartScaffold();
  chartCard.dataset.type = "line";
  let eventRegistry = [];
  requestAnimationFrame(() => {
    lineChart(canvas, chart, {
      axisX: xChartAxis,
      axisY: yChartAxis,
      viewport: chartViewport,
      selfRepaint: repaint,
      selfRepaintArguments: repaintArguments
    });
    let scheduledBlur;
    [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => {
      let setBlur = e => {
        chartHolder.style.opacity = 1;
        [...chartCard.querySelectorAll(".chart-repaint-frame .overlay-chart-holder")].forEach(overlayChartHolder => {
          overlayChartHolder.style.opacity = 0;
          setTimeout(() => {
            overlayChartHolder.remove();
          }, 300);
        });
        chartCard.querySelector(`.chart-legend`).classList.remove("active");
        [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => item.classList.remove("active"));
        chartCard.style.setProperty("--chart-hover-color", "");
        chartCard.classList.remove("chart-active");
      };

      let setActive = e => {
        clearTimeout(scheduledBlur);
        setBlur();
        const {
          chartHolder: overlayChartHolder,
          canvas: overlayCanvas,
          xChartAxis: overlayXChartAxis,
          yChartAxis: overlayYChartAxis,
          chartViewport: overlayChartViewport
        } = createChartScaffold();
        chartCard.querySelector(`.chart-legend`).classList.add("active");
        chartCard.classList.add("chart-active");
        [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(compareItem => {
          if (compareItem === item) {
            compareItem.classList.add("active");
          }
        });
        overlayChartHolder.classList.add("chart-holder");
        overlayChartHolder.classList.add("overlay-chart-holder");
        overlayChartHolder.style.opacity = 0;
        chartCard.querySelector(".chart-repaint-frame").appendChild(overlayChartHolder);
        lineChart(overlayCanvas, chart, {
          axisX: overlayXChartAxis,
          axisY: overlayYChartAxis,
          viewport: overlayChartViewport,
          activeSetId: parseInt(item.dataset.idx),
          selfRepaintArguments: repaintArguments
        });
        requestAnimationFrame(() => {
          chartHolder.style.opacity = 0;
          if (overlayChartHolder) overlayChartHolder.style.opacity = 1;
          chartCard.style.setProperty("--chart-hover-color", item.querySelector(".chart-legend-item-color").style.background);
        });
      };

      function debouncedBlur() {
        clearTimeout(scheduledBlur);
        scheduledBlur = setTimeout(setBlur, 100);
      }

      function reactToEnterMouse() {
        setActive();
      }

      function reactToLeaveMouse() {
        debouncedBlur();
      }

      item.addEventListener("mouseenter", reactToEnterMouse, {
        passive: true
      });
      item.addEventListener("mouseleave", reactToLeaveMouse, {
        passive: true
      });
      eventRegistry.push(() => {
        item.removeEventListener("mouseenter", reactToEnterMouse, {
          passive: true
        });
        item.removeEventListener("mouseleave", reactToLeaveMouse, {
          passive: true
        });
      });
    });
  });

  chartHolder.destroy = () => {
    eventRegistry.forEach(fn => fn());
  };

  return chartHolder;
}